export const approveProposal = async (proposal) => {
  proposal.status = "approved";
  proposal.dataAtualizacao = Date.now();
};

export const rejectProposal = async (proposal) => {
  proposal.status = "rejected";
  proposal.dataAtualizacao = Date.now();
};

export const deleteProposal = async (id) => {
  console.log("Proposta expirou e será excluída futuramente!");
};
